import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../store';

export function SignedInView() {
  const { t } = useTranslation();
  const user = useAuth(s => s.user);
  const handleLogout = useAuth(s => s.handleLogout);

  return (
    <div className="flex items-center justify-between">
      <span className="text-sm text-green-600 font-medium">
        ✓ {user?.name ?? user?.email ?? t('storeSettings.loggedIn')}
      </span>
      <button
        onClick={handleLogout}
        className="rounded-lg border border-red-200 px-3 py-1.5 text-sm text-red-600 hover:bg-red-50"
      >
        {t('storeSettings.logout')}
      </button>
    </div>
  );
}
